import { axiosAdapter } from 'foca-openapi/adapters/axios';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import http from './http';

export const parrotApi = new OpenapiClientParrotVault(axiosAdapter(http, (res) => res));
